import React from "react";

export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Meet Management Team</h2>
          <p>
    Our management team is driven by a strong focus on research and innovation. Led by our chief architect with years of coding experience and a decade in leadership, the team brings deep expertise in developing scalable, intelligent solutions. With a proven track record in leading startups and impactful projects across various tech sectors, our leaders are dedicated to advancing product development and driving technological excellence.
          </p>
        </div>
        <div id="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 team">
                  <div className="thumbnail">
                    {" "}
                    <img src={d.img} alt="..." className="team-img" />
                    <div className="caption">
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
